import { render, staticRenderFns } from "./v-order-confirmation-address-form.vue?vue&type=template&id=b2478cf6&scoped=true"
import script from "./v-order-confirmation-address-form.vue?vue&type=script&lang=js"
export * from "./v-order-confirmation-address-form.vue?vue&type=script&lang=js"
import style0 from "./v-order-confirmation-address-form.vue?vue&type=style&index=0&id=b2478cf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2478cf6",
  null
  
)

export default component.exports